import React, { useState } from "react";
import {
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
  Box,
} from "@mui/material";

const TrialClassForm = () => {
  const [formData, setFormData] = useState({
    studentName: "",
    mobileNumber: "",
    board: [],
    subject: [],
    class: "",
    trialClassDate: "",
    trialClassTime: [],
    feePerMonth: [],
    fullAddress: "",
    amount: "",
    agree: false,
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleMultiChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (event) => {
    setFormData({ ...formData, agree: event.target.checked });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(formData);
  };

  return (
    <Box
      sx={{
        maxWidth: 500,
        margin: "auto",
        padding: 4,
        backgroundColor: "#1a237e",
        borderRadius: 2,
        color: "white",
      }}
    >
      <Typography variant="h5" align="center" gutterBottom>
        DOOR STEP EDU GROUP
      </Typography>
      <Typography variant="h6" align="center" gutterBottom>
        Trial Class Form
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Student Name"
          name="studentName"
          fullWidth
          required
          variant="outlined"
          margin="normal"
          value={formData.studentName}
          onChange={handleChange}
          sx={{ backgroundColor: "white" }}
        />
        <TextField
          label="Mobile Number"
          name="mobileNumber"
          fullWidth
          required
          variant="outlined"
          margin="normal"
          value={formData.mobileNumber}
          onChange={handleChange}
          sx={{ backgroundColor: "white" }}
        />
        <FormControl fullWidth margin="normal">
          <InputLabel>Board</InputLabel>
          <Select
            multiple
            name="board"
            value={formData.board}
            onChange={handleMultiChange}
          >
            {[
              "IGCSE",
              "CBSE",
              "ICSE",
              "State Board",
              "IB",
            ].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal">
          <InputLabel>Subjects</InputLabel>
          <Select
            multiple
            name="subject"
            value={formData.subject}
            onChange={handleMultiChange}
          >
            {[
              "Maths",
              "Science",
              "English",
              "Physics",
              "Biology",
            ].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Class"
          name="class"
          fullWidth
          required
          variant="outlined"
          margin="normal"
          value={formData.class}
          onChange={handleChange}
          sx={{ backgroundColor: "white" }}
        />
        <TextField
          type="date"
          name="trialClassDate"
          fullWidth
          required
          variant="outlined"
          margin="normal"
          value={formData.trialClassDate}
          onChange={handleChange}
          sx={{ backgroundColor: "white" }}
        />
        <FormControl fullWidth margin="normal">
          <InputLabel>Trial Class Time</InputLabel>
          <Select
            multiple
            name="trialClassTime"
            value={formData.trialClassTime}
            onChange={handleMultiChange}
          >
            {["7 am to 8 am", "9 am to 10 am", "5 pm to 6 pm"].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal">
          <InputLabel>Fee per Month</InputLabel>
          <Select
            multiple
            name="feePerMonth"
            value={formData.feePerMonth}
            onChange={handleMultiChange}
          >
            {["6000-9000", "9000-12000", "12000-15000"].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Full Address"
          name="fullAddress"
          fullWidth
          required
          variant="outlined"
          margin="normal"
          value={formData.fullAddress}
          onChange={handleChange}
          sx={{ backgroundColor: "white" }}
        />
        <TextField
          label="Amount (including GST)"
          name="amount"
          fullWidth
          required
          variant="outlined"
          margin="normal"
          value={formData.amount}
          onChange={handleChange}
          sx={{ backgroundColor: "white" }}
        />
        <FormControlLabel
          control={<Checkbox checked={formData.agree} onChange={handleCheckboxChange} />}
          label="I agree to the Privacy Policy and Terms & Conditions"
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 2, background: "linear-gradient(to right, red, orange)" }}
        >
          SUBMIT
        </Button>
      </form>
    </Box>
  );
};

export default TrialClassForm;
